import { render, staticRenderFns } from "./PropertyInfo.vue?vue&type=template&id=023ab14c"
import script from "./PropertyInfo.vue?vue&type=script&lang=js"
export * from "./PropertyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports